import React from "react";
// import Input from "./Input"
import { Input, Dropdown } from "semantic-ui-react";
import AppSettings from "lib/services/AppSettings";

const formatCurrency = (c) => (c === "percentage" ? "%" : c);

export default function MoneyControl({
  onFocus,
  onBlur,
  onChange,
  value,
  placeholder,
  defaultCurrency,
  currencies,
  currencyEditable = true,
  withPercentageCurrency = false,
  readOnly,
  disabled,
  className,
  ...rest
}) {
  if (value === undefined) {
    throw new Error("MoneyControl: argument 'value' is undefined");
  }

  if (defaultCurrency === undefined) {
    defaultCurrency = (placeholder && placeholder.currency) || (currencies && currencies[0]);
  }

  const money = value || { value: null, currency: null };
  if (!money.currency && !defaultCurrency) {
    throw new Error("MoneyControl: both money.currency and defaultCurrency are empty");
  }

  if (currencies === undefined) {
    currencies = AppSettings.backend_currencies.filter((currency) => !["GBP",  "TRY"].includes(currency));
  }
  if (!currencyEditable) {
    currencies = [money.currency];
  }
  if (withPercentageCurrency) {
    currencies = ["percentage"].concat(currencies);
  }

  const dropdownOptions = currencies
    .filter((c) => !["GBP", "TRY"].includes(formatCurrency(c))) // Fix prevent to USD and GBP
    .map((c) => ({
      value: c,
      text: formatCurrency(c),
    }));

  let label = (
    <input
      className="label"
      value={formatCurrency(money.currency || defaultCurrency)}
      readOnly
      disabled={!money.currency}
    />
  );
  if (
    !(readOnly || disabled) &&
    (dropdownOptions.length > 1 || (dropdownOptions.length === 1 && dropdownOptions[0].value !== money.currency))
  ) {
    label = (
      <Dropdown
        compact
        selection
        value={money.currency || ""}
        placeholder={formatCurrency(defaultCurrency)}
        options={dropdownOptions}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={
          onChange &&
          ((event, { value: currency }) =>
            onChange({ value: money.value || (placeholder && placeholder.value) || 0, currency }))
        }
      />
    );
  }

  const handleChange =
    onChange &&
    ((event, { value }) => {
      if (value === "" || value === null) {
        onChange(null);
      } else {
        onChange({
          value: +value,
          currency: money.currency || defaultCurrency,
        });
      }
    });

  return (
    <Input
      className={"MoneyControl " + (className || "")}
      type="number"
      step="0.01"
      value={money.value === null ? "" : money.value}
      placeholder={placeholder && placeholder.value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={handleChange}
      label={label}
      labelPosition="right"
      readOnly={readOnly}
      disabled={disabled}
      {...rest}
    />
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Money.jsx